const KEY_DIRECTIONS = { ArrowLeft: `prev`, ArrowRight: `next` }

// `prev` / `next` for a ← / → `keydown` meant for prev/next navigation (e.g.
// slides), otherwise `null`: other keys, keys with modifiers (browser
// shortcuts like Alt+← for back, text selection), keys typed into form fields
// and keys already handled
export const keyDirection = (e) => {
  const direction = KEY_DIRECTIONS[e.key]

  if (!direction || e.defaultPrevented) return null
  if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return null
  if (e.target.closest?.(`input, textarea, select, [contenteditable]`))
    return null

  return direction
}
